export const SOFTLINE_API_STORAGE_LOCATION_SCAN =
  '/locationassignment-service/storageLocation/scan';
export const SOFTLINE_API_STORAGE_LOCATION_LOCATIONS =
  '/locationassignment-service/storageLocation/storageLocations';
export const SOFTLINE_API_STORAGE_LOCATION_PRODUCTS =
  '/locationassignment-service/storageLocation/{{idStorage}}/products';
export const SOFTLINE_API_STORAGE_LOCATION_PRODUCTS_UPDATE_POSITION =
  '/locationassignment-service/storageLocation/{{idStorage}}/products/updatePositions';
export const SOFTLINE_API_STORAGE_LOCATION_PRODUCT =
  '/locationassignment-service/storageLocation/{{idStorage}}/products/{{idProduct}}';
